import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import "primereact/resources/themes/viva-dark/theme.css";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import UserImage from "components/commons/UserImage";
import Modal from "components/commons/Modal";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import EntityFingerprint from "components/commons/EntityFingerprint";
import HasPermission, { CanGrantCriticalRoles } from "app/PermissionChecker";

function EmploymentsTable({
    employmentsData,
    toggleStatus = () => { },
    onUserDelete = () => { }
}) {

    const [t, i18n] = useTranslation(["global"])
    const [expandedRows, setExpandedRows] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    const dt = useRef(null);

    const expandAll = () => {
        let _expandedRows = {};

        employmentsData.forEach((p) => (_expandedRows[`${p.guid}`] = true));

        setExpandedRows(_expandedRows);
    };

    const collapseAll = () => {
        setExpandedRows(null);
    };

    /**
     *
     *  TEMPLATE HOLDERS 
     * 
     * */

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <i className="fa-solid fa-magnifying-glass me-2"></i>
                <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Cerca" autoFocus />
                {/* <input value={globalFilterValue}onChange={onGlobalFilterChange} autoFocus/> */}
            </div>
        );
    };

    const statusTemplate = (employment) => {
        return (
            <div className="form-check form-switch">
                <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" disabled={employment.role.isCritical} checked={employment.user.enabled} onChange={(e) => { handleChangeStatus(e, employment.user.guid) }} />
            </div>
        )
    }

    const avatarTemplate = (employment) => {
        return <UserImage guid={employment.user.guid} />
    }

    const displayNameTemplate = (employment) => {
        return <>

            <span>{employment.user.displayName}</span>
        </>
    }

    const roleTemplate = (employment) => {
        return <span className="badge " style={{ backgroundColor: employment.role.backgroundColor, color: employment.role.textColor, padding: "10px" }}> {employment.role.name} </span>
    }

    const currentUserCanGrantCriticalRole = HasPermission(CanGrantCriticalRoles)

    const actionsTemplate = (employment) => {
        return (
            <>
                <NavLink to={{ pathname: "/dashboard/employees/see-employment" }} state={{ userGUID: employment.user.guid }} className="btn btn-light me-1"><i className="fa-solid fa-eye"></i></NavLink>
                <NavLink to={{ pathname: "/dashboard/employees/edit-employment" }} state={{ userGUID: employment.user.guid }} className={`btn btn-light me-1 ${employment.role.isCritical && !currentUserCanGrantCriticalRole ? "disabled" : null}`} disabled={employment.role.isCritical}><i className="fa-solid fa-pen"></i></NavLink>
                <Modal
                    modalId={"employee_delete_" + employment.user.username}
                    modalLocked={employment.role.isCritical && !currentUserCanGrantCriticalRole}
                    buttonClass="btn btn-danger"
                    buttonIcon={<i className="fa-solid fa-trash"></i>}
                    buttonLabel={t("action.delete")}
                    iconOnly={true}
                    body={t("helper.generic_entity_deleting")}
                    onConfirm={() => onUserDelete(employment.user.guid)}
                />


            </>
        )
    }

    const rowExpansionTemplate = (data) => {
        console.log("RowExpanded: " + data.user.displayName)
        return (
            <div className="container">
                <div className="row px-4 align-items-start">
                    <div className="col-3">
                        <h6 className="text-accent"><i className="fa-solid fa-briefcase"></i> {t("menu.employment_info")}</h6>
                        <p className="fs-6 text-muted">{t("helper.employed_on_as", { date: new Date(data.startDateTimeMillis).toLocaleDateString(), roleDesc: data.role.description })}</p>
                    </div>
                    <div className="col-3">
                        <h6 className="text-accent" ><i className="fa-solid fa-user"></i> Username</h6>
                        <span className="text-muted">{data.user.username} </span> <br />
                    </div>
                    <div className="col-4">
                        <h6 className="text-accent"><i className="fa-solid fa-briefcase"></i> {t("property.email")}</h6>
                        <span className="text-muted">{data.user.email} </span>
                    </div>
                    <div className="col-2">
                    <h6 className="text-accent">ID</h6>
                        <EntityFingerprint guid={data.user.guid}/>
                    </div>
                </div>
                {/* <div className="row px-4 align-items-start">
                    <div className="col px-4">
                        <p className="text-muted">employment_id <span className="bg-dark">{data.guid}</span></p>
                    </div>
                    <div className="col px-4">
                        <p className="text-muted">user_id <span className="bg-dark">{data.user.guid}</span></p>

                    </div>
                </div> */}

            </div>
        )
    }



    /**
     *
     *  ACTION HANDLERS 
     * 
     * */

    const handleChangeStatus = (e, guid) => {
        console.log("Set status: " + e.target.checked + " on userGuid: " + guid)
        toggleStatus(e.target.checked, guid)
    }


    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({ selectionOnly });
    };

    const header = renderHeader();

    return (
        <>
            <DataTable
                value={employmentsData}
                stripedRows
                tableStyle={{ minWidth: '50rem' }}
                paginator rows={25}
                rowsPerPageOptions={[5, 10, 25, 50]}

                dataKey="guid"
                expandedRows={expandedRows}
                onRowToggle={(e) => setExpandedRows(e.data)}
                rowExpansionTemplate={rowExpansionTemplate}
                globalFilterFields={['user.displayName', 'role.name', 'businessUnit.name']}
                ref={dt}
                header={header}
                onFilter={(e) => setFilters(e.filters)}
                filters={filters}
                emptyMessage="No customers found."
            >
                <Column expander={() => { return true }} style={{ width: '5rem' }} />
                <Column body={avatarTemplate}   ></Column>
                <Column body={displayNameTemplate} field="user.displayName" header={t("property.name")}  sortable ></Column>
                <Column body={roleTemplate} header={t("property.role")} field="role.name" sortable></Column>
                <Column field="businessUnit.name" header={t("property.site")} sortable></Column>
                <Column body={statusTemplate} header={t("property.status")} dataType="boolean" field="user.enabled"></Column>
                <Column body={actionsTemplate} header={t("property.actions")}></Column>
            </DataTable>
            <div className="container text-end p-2">
                <h6>{t("action.export")}</h6>
                <button className="btn btn-primary" onClick={() => exportCSV(false)}><i className="fa-solid fa-download"></i> .CSV</button>
            </div>
        </>


    )

}

export default EmploymentsTable